import { z } from 'zod';

// The enum values are based on the icon name in most cases, but during development, some icons had a name change.
// There should be comments to indicate name differences to make it easier to track changes.
export const IconSchema = z.enum([
  'ACCOUNT',
  'ACTIVITY', // iconBrain
  'ADD',
  'APPS',
  'ARCHIVE',
  'ARROW_BACK',
  'ARROW_BEND_DOWN_RIGHT',
  'ARROW_DOWN',
  'ARROW_FORWARD',
  'ARROW_UP',
  'AUDIO',
  'BADGE',
  'BOOK',
  'BRUSH',
  'BRUSH_BIG',
  'CALENDAR',
  'CAMERA',
  'CART',
  'CHECK',
  'CHECK_FILL',
  'CHECKBOX',
  'CHECKBOX_CHECKED',
  'CHEVRON_DOWN',
  'CHEVRON_LEFT',
  'CHEVRON_RIGHT',
  'CHEVRON_UP',
  'CLASSROOM',
  'CLIP',
  'CLOSE',
  'CLOUD',
  'CLOUD_DOWNLOAD',
  'CLOUD_UPLOAD_ADD',
  'CLOUD_UPLOAD_DONE',
  'COINS',
  'COLOR',
  'COLUMNS',
  'COGWHEEL',
  'COMPONENT_FORMULA',
  'COOKIE',
  'COPY',
  'CUT',
  'DELETE',
  'DESKTOP',
  'DICE',
  'DIFFERENTIATION',
  'DOWNLOAD',
  'DROP',
  'EDIT',
  'EMAIL',
  'EMOJI_LAUGH',
  'ENLARGE',
  'ERASER',
  'EURO',
  'EYE',
  'FEEDBACK',
  'FILE',
  'FILE_TEXT',
  'FLAG',
  'FLOW_CHART_ACTION_FILL',
  'FOLDER',
  'HAND_RAISED',
  'HEADPHONES',
  'HEART_OUTLINE',
  'HELP',
  'HISTORY',
  'HOME',
  'IMAGE',
  'IMAGE_STACK',
  'INBOX',
  'INFINITY',
  'INFO',
  'JOYSTICK',
  'KEYBOARD',
  'LANGUAGE',
  'LAPTOP',
  'LESSON',
  'LESSON_PLAN',
  'LINK',
  'LOCK', // iconLockClosed
  'LOCK_OPEN',
  'LUGGAGE',
  'LUNCH', // iconCroissant
  'MAP',
  'MEDIA_LIBRARY', // iconPageLibrary
  'MEGAPHONE',
  'MAGNIFYING_GLASS',
  'MICROPHONE',
  'MINUS',
  'MULTIPLY',
  'NOTE',
  'NOTIFICATIONS', // iconNotificationOn
  'OPEN_IN_NEW',
  'PARAGRAPH',
  'PASTE',
  'PAYMENT',
  'PENCIL',
  'PENSION',
  'PEOPLE',
  'PERSON',
  'PHONE',
  'PLANET',
  'PLANT',
  'PLAY',
  'PLUS',
  'PIN',
  'POWER',
  'POWERPOINT',
  'PRESENT',
  'PRESENTER',
  'PRINT',
  'PRIVACY',
  'QUESTION', // iconUnmarked
  'RADIO_BUTTON',
  'RADIO_TOWER',
  'REPORT',
  'REFRESH',
  'RESET',
  'ROBOT',
  'ROCKET',
  'RULER',
  'SCHOOL',
  'SEARCH',
  'SEND',
  'SHARE_ALT',
  'SHRINK',
  'SHOPPING_BAG',
  'SLIDE_TYPE_POLL',
  'STACK',
  'STAR_OUTLINE', // iconStar
  'STAR_FILL',
  'STOP_FILL',
  'STUDENT',
  'STUDENT_HAT', // iconGraduationCap
  'SUN',
  'SUPPORT',
  'TEST', // iconPageAssessments
  'TIME',
  'TRAFFIC', // iconComponentTraffic
  'TRANSPORT',
  'TROPHY',
  'UPLOAD',
  'VIDEO', // iconComponentVideo
  'VISIBILITY_OFF',
  'VOUCHER',
  'WAND',
  'WARNING',
  'WRENCH',
  'ZOOM_IN',
  'ZOOM_OUT',
]);
export type IconSettingsKey = z.infer<typeof IconSchema>;
